import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  location: string;
  role: string;
}
export function TestimonialCard({
  quote,
  name,
  location,
  role
}: TestimonialCardProps) {
  return <div className="bg-dark-800 border border-dark-700 p-5 md:p-8 rounded-2xl flex flex-col h-full hover:border-lime-500/50 transition-colors duration-300" data-id="element-383">
      <div className="flex gap-1 mb-3 md:mb-6" data-id="element-384">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-lime-500 text-lime-500" data-id="element-385" />)}
      </div>
      <blockquote className="text-gray-300 text-base md:text-lg leading-relaxed flex-grow mb-4 md:mb-8 font-medium" data-id="element-386">
        "{quote}"
      </blockquote>
      <div className="mt-auto" data-id="element-387">
        <div className="font-display font-bold text-white text-base md:text-lg" data-id="element-388">
          {name}
        </div>
        <div className="text-lime-400 text-xs md:text-sm font-medium mb-1" data-id="element-389">
          📍 {location}
        </div>
        <div className="text-gray-500 text-xs md:text-sm" data-id="element-390">{role}</div>
      </div>
    </div>;
}